    import React, { useState, useEffect } from 'react';
    import Pagination from '../common/Pagination';
    import './ContentGallery.scss';
    import { getThumbnailUrl } from '../../utils/imageAssets';

    const ContentGallery = ({ contents, onOpenContent }) => {
    const [typeFilter, setTypeFilter] = useState("youtube");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6;

    // 필터 변경시 페이지를 1로 리셋
    useEffect(() => {
        setCurrentPage(1);
    }, [typeFilter]);

    // featured가 아닌 콘텐츠만 필터링
    const getFilteredContents = (typeFilter) => {
        return contents.filter((c) => !c.featured && c.type === typeFilter);
    };

    const filtered = getFilteredContents(typeFilter);
    
    // 페이지네이션 계산
    const totalPages = Math.ceil(filtered.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentItems = filtered.slice(startIndex, startIndex + itemsPerPage);
    
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className="content-gallery">
        <div className="hub-filters">
            <div className="filter-row">
            <button 
                type="button" 
                className={`pill ${typeFilter === "youtube" ? "active" : ""}`} 
                onClick={() => setTypeFilter("youtube")}
            >
                영상
            </button>
            <button 
                type="button" 
                className={`pill ${typeFilter === "cardnews" ? "active" : ""}`} 
                onClick={() => setTypeFilter("cardnews")}
            >
                카드뉴스
            </button>
            </div>
        </div>

        <div className="gallery-grid">
            {currentItems.map((c) => (
            <button 
                key={c.id} 
                className="gallery-card" 
                type="button" 
                onClick={() => onOpenContent(c)}
            >
                <div className="thumb">
                <img src={getThumbnailUrl(c.thumb)} alt={c.title} loading="lazy" decoding="async" />
                </div>

                <div className="meta">
                {/* <div className="card-title">{c.title}</div> */}
                <div className="card-desc">{c.desc}</div>
                </div>
            </button>
            ))}
        </div>
        
        {/* 페이지네이션 */}
        {totalPages > 1 && (
            <Pagination 
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            />
        )}
        </div>
    );
    };

    export default ContentGallery;
